export const AffirmFooterLogo = () => (
  <svg
    width="61"
    height="24"
    viewBox="0 0 61 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-label="affirm-logo"
  >
    <g clipPath="url(#clip0_3007_3060)">
      <mask
        id="mask0_3007_3060"
        style={{ maskType: 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="61"
        height="24"
      >
        <path d="M60.9364 0H0.789062V24H60.9364V0Z" fill="currentColor"></path>
      </mask>
      <g mask="url(#mask0_3007_3060)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.7328 21.9329C3.98894 21.9329 3.61 21.5665 3.61 20.9644C3.61 19.8416 4.86193 19.4641 7.14543 19.2213C7.14543 20.7174 6.1335 21.9329 4.72578 21.9329H4.7328ZM5.71526 13.5188C4.08298 13.5188 2.20649 14.2865 1.18754 15.0992L2.11806 17.0641C2.93491 16.316 4.25561 15.676 5.44719 15.676C6.57982 15.676 7.20578 16.055 7.20578 16.8185C7.20578 17.3308 6.79175 17.5904 6.00859 17.6929C3.08087 18.0718 0.786133 18.8802 0.786133 21.1357C0.786133 22.9237 2.05912 24.0058 4.04789 24.0058C5.46824 24.0058 6.7314 23.2171 7.3321 22.1813V23.7251H9.97912V17.2564C9.97912 14.5897 8.12789 13.5132 5.71666 13.5132L5.71526 13.5188Z"
          fill="currentColor"
        ></path>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M32.2822 13.8092V23.7123H35.1145V18.9404C35.1145 16.6737 36.4871 16.007 37.4429 16.007C37.8732 16.0037 38.2947 16.1283 38.6542 16.3649L39.1721 13.7474C38.7706 13.5868 38.341 13.5089 37.9089 13.5186C36.4535 13.5186 35.5384 14.1628 34.9349 15.4737V13.8092H32.2822Z"
          fill="currentColor"
        ></path>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M52.2977 13.5188C50.8002 13.5188 49.6802 14.403 49.0977 15.2564C48.5574 14.1546 47.4135 13.5188 46.0381 13.5188C44.5419 13.5188 43.5047 14.3497 43.0261 15.3069V13.8093H40.2949V23.7125H43.13V18.6136C43.13 16.789 44.0886 15.9062 44.9826 15.9062C45.7925 15.9062 46.5363 16.4297 46.5363 17.7813V23.7125H49.3658V18.6136C49.3658 16.7623 50.3005 15.9062 51.2367 15.9062C51.9861 15.9062 52.7805 16.4508 52.7805 17.7616V23.7125H55.61V16.8662C55.61 14.6416 54.1125 13.5188 52.3033 13.5188"
          fill="currentColor"
        ></path>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M25.3899 13.8093H22.8243V12.803C22.8243 11.4921 23.5724 11.1188 24.2166 11.1188C24.6565 11.1245 25.0889 11.2326 25.4798 11.4346L26.3527 9.43738C26.3527 9.43738 25.4671 8.85913 23.8573 8.85913C22.0482 8.85913 19.9892 9.87948 19.9892 13.0809V13.8093H15.7015V12.803C15.7015 11.4921 16.4482 11.1188 17.0938 11.1188C17.5344 11.1188 17.9682 11.2272 18.3569 11.4346L19.2299 9.43738C18.7092 9.13281 17.8713 8.85913 16.7359 8.85913C14.9268 8.85913 12.8678 9.87948 12.8678 13.0809V13.8093H11.2285V15.9932H12.872V23.7125H15.7015V15.9932H19.9948V23.7125H22.8243V15.9932H25.3899V13.8093Z"
          fill="currentColor"
        ></path>
        <path d="M29.9058 13.8093H27.0791V23.7083H29.9058V13.8093Z" fill="currentColor"></path>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M27.1836 12.1264H29.9527C31.5682 7.04714 37.0489 2.58258 43.5668 2.58258C51.4938 2.58258 58.3443 8.61766 58.3443 18.0128C58.3684 19.9412 58.1035 21.8624 57.5583 23.7124H60.2461L60.2727 23.6198C60.7256 21.7883 60.9491 19.9078 60.938 18.0212C60.938 7.54398 53.3029 0.00292969 43.5724 0.00292969C35.9289 0.00292969 29.1162 5.30819 27.185 12.1292L27.1836 12.1264Z"
          fill="currentColor"
        ></path>
      </g>
    </g>
    <defs>
      <clipPath>
        <rect
          width="60.2105"
          height="24"
          fill="currentColor"
          transform="translate(0.789062)"
        ></rect>
      </clipPath>
    </defs>
  </svg>
);

export const PrenuvoFooterLogo = () => (
  <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_3007_3040)">
      <path
        d="M80 48.0479C80 48.8103 79.3813 49.4234 78.624 49.4234H1.376C0.613333 49.4234 0 48.805 0 48.0479C0 47.2855 0.618667 46.6724 1.376 46.6724H23.344H78.624C79.3867 46.6724 80 47.2908 80 48.0479Z"
        fill="currentColor"
      ></path>
      <path
        d="M23.344 46.6724C10.4693 46.6724 0 36.2013 0 23.3362C0 10.4712 10.4693 0 23.344 0C36.2133 0 46.688 10.4658 46.688 23.3362C46.688 36.2013 36.2187 46.6724 23.344 46.6724ZM43.9307 23.3362C43.9307 11.9853 34.6933 2.75641 23.344 2.75641C11.9893 2.75641 2.75733 11.9907 2.75733 23.3362C2.75733 34.6871 11.9947 43.916 23.344 43.916C34.6987 43.916 43.9307 34.6818 43.9307 23.3362Z"
        fill="currentColor"
      ></path>
      <path
        d="M55.5205 72.6529C55.2271 72.6529 54.9871 72.413 54.9871 72.1198V70.7656C54.0805 71.9172 52.6725 72.6529 51.0938 72.6529C48.3631 72.6529 46.1391 70.4297 46.1338 67.6999V62.3684C46.1338 62.0751 46.3738 61.8352 46.6671 61.8352C46.9605 61.8352 47.2005 62.0751 47.2005 62.3684V67.6999C47.2005 69.8432 48.9498 71.5866 51.0938 71.5866C53.2378 71.5866 54.9871 69.8432 54.9871 67.6946V62.3684C54.9871 62.0751 55.2271 61.8352 55.5205 61.8352C55.8138 61.8352 56.0538 62.0751 56.0538 62.3684V72.1198C56.0538 72.413 55.8138 72.6529 55.5205 72.6529Z"
        fill="currentColor"
      ></path>
      <path
        d="M63.4083 72.653C63.2003 72.653 63.0136 72.5304 62.923 72.3438L58.411 62.5817C58.2883 62.3151 58.4056 61.9952 58.6723 61.8726C58.9443 61.75 59.259 61.8673 59.3816 62.1339L63.403 70.835L67.3123 62.1392C67.435 61.8726 67.7496 61.75 68.0163 61.8726C68.283 61.9952 68.4056 62.3098 68.283 62.5764L63.8936 72.3385C63.8083 72.5304 63.6163 72.653 63.4083 72.653Z"
        fill="currentColor"
      ></path>
      <path
        d="M6.52812 72.653C3.54678 72.653 1.12012 70.2271 1.12012 67.2468C1.12012 64.2664 3.54678 61.8406 6.52812 61.8406C9.50945 61.8406 11.9361 64.2664 11.9361 67.2468C11.9361 70.2271 9.50945 72.653 6.52812 72.653ZM6.52812 62.9016C4.13345 62.9016 2.18678 64.8476 2.18678 67.2414C2.18678 69.6353 4.13345 71.5813 6.52812 71.5813C8.92278 71.5813 10.8694 69.6353 10.8694 67.2414C10.8694 64.8476 8.92278 62.9016 6.52812 62.9016Z"
        fill="currentColor"
      ></path>
      <path
        d="M74.5916 72.653C71.6103 72.653 69.1836 70.2271 69.1836 67.2468C69.1836 64.2664 71.6103 61.8406 74.5916 61.8406C77.5729 61.8406 79.9996 64.2664 79.9996 67.2468C79.9996 70.2271 77.5729 72.653 74.5916 72.653ZM74.5916 62.9016C72.1969 62.9016 70.2503 64.8476 70.2503 67.2414C70.2503 69.6353 72.1969 71.5813 74.5916 71.5813C76.9863 71.5813 78.9329 69.6353 78.9329 67.2414C78.9329 64.8476 76.9863 62.9016 74.5916 62.9016Z"
        fill="currentColor"
      ></path>
      <path
        d="M14.7042 72.6529C14.4109 72.6529 14.1709 72.413 14.1709 72.1198V62.3684C14.1709 62.0751 14.4109 61.8352 14.7042 61.8352C14.9976 61.8352 15.2376 62.0751 15.2376 62.3684V63.7226C16.1442 62.5763 17.5469 61.8352 19.1149 61.8352C19.4082 61.8352 19.6482 62.0751 19.6482 62.3684C19.6482 62.6616 19.4082 62.9015 19.1149 62.9015C16.9762 62.9015 15.2376 64.6449 15.2376 66.7935V72.1198C15.2376 72.413 14.9976 72.6529 14.7042 72.6529Z"
        fill="currentColor"
      ></path>
      <path
        d="M0.533333 79.9998C0.24 79.9998 0 79.7652 0 79.4667V62.3684C0 62.0751 0.24 61.8352 0.533333 61.8352C0.826667 61.8352 1.06667 62.0751 1.06667 62.3684V79.4667C1.06667 79.7599 0.826667 79.9998 0.533333 79.9998Z"
        fill="currentColor"
      ></path>
      <path
        d="M26.1543 72.653C23.237 72.653 20.8477 70.3284 20.7463 67.4387C20.725 67.3801 20.709 67.3161 20.709 67.2468C20.709 67.1775 20.7196 67.1188 20.741 67.0602C20.789 65.6846 21.3436 64.3997 22.3196 63.424C23.3436 62.4004 24.7036 61.8406 26.149 61.8406C29.1463 61.8406 31.589 64.2664 31.589 67.2468C31.589 67.54 31.349 67.7853 31.0557 67.7853H21.8397C22.1063 69.9285 23.9356 71.592 26.149 71.592C27.3063 71.592 28.3996 71.1388 29.2156 70.3231C29.4236 70.1151 29.7597 70.1151 29.973 70.3231C30.181 70.531 30.181 70.8669 29.973 71.0802C28.949 72.0985 27.5943 72.6636 26.149 72.6636L26.1543 72.653ZM21.845 66.7136H30.4957C30.229 64.565 28.3837 62.9016 26.1543 62.9016C24.9917 62.9016 23.9036 63.3547 23.0823 64.1758C22.389 64.8689 21.9623 65.7539 21.845 66.7136Z"
        fill="currentColor"
      ></path>
      <path
        d="M43.2958 72.6529C43.0025 72.6529 42.7625 72.413 42.7625 72.1198V66.7882C42.7625 64.6449 41.0132 62.9015 38.8692 62.9015C36.7252 62.9015 34.9758 64.6449 34.9758 66.7935V72.1198C34.9758 72.413 34.7358 72.6529 34.4425 72.6529C34.1492 72.6529 33.9092 72.413 33.9092 72.1198V62.3684C33.9092 62.0751 34.1492 61.8352 34.4425 61.8352C34.7358 61.8352 34.9758 62.0751 34.9758 62.3684V63.7226C35.8825 62.571 37.2905 61.8352 38.8692 61.8352C41.5998 61.8352 43.8238 64.0585 43.8292 66.7882V72.1198C43.8292 72.413 43.5892 72.6529 43.2958 72.6529Z"
        fill="currentColor"
      ></path>
    </g>
    <defs>
      <clipPath>
        <rect width="80" height="80" fill="currentColor"></rect>
      </clipPath>
    </defs>
  </svg>
);
